'use client'

import { usePathname, useRouter } from 'next/navigation'
import { useState, useEffect } from 'react'
import routes from '@/router/routing_role.json'
import { useInnocodeLoadingOverlay } from '@intsoft/innocode-core'

/**
 * 라우트 매칭 및 로딩 오버레이만 담당 (스타일 파일 로드 제거)
 */
export default function PageStyleLoader() {
  const { show: showLoading, hide: hideLoading } = useInnocodeLoadingOverlay()
  const pathname = usePathname()
  const router = useRouter()
  const [isLoading, setIsLoading] = useState(true)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  useEffect(() => {
    if (!isMounted) return
    if (isLoading) {
      showLoading()
    } else {
      hideLoading()
    }
  }, [isMounted, isLoading, showLoading, hideLoading])

  useEffect(() => {
    if (!isMounted) return

    const matchRoute = (route: { pageSlug: string }) => {
      const slug = route.pageSlug
      if (slug === pathname) return true
      if (slug.includes(':')) {
        const pattern = slug.replace(/:[^/]+/g, '[^/]+')
        const regex = new RegExp(`^${pattern}$`)
        return regex.test(pathname)
      }
      return false
    }
    const currentRoute = routes.find((r: any) => matchRoute(r))

    if (!currentRoute) {
      router.push('/error/pageNotFound')
      return
    }

    setIsLoading(false)
    const el = document.getElementById('root')
    if (el) el.classList.add('loaded')
  }, [pathname, isMounted, router])

  if (!isMounted) return null
  return null
} 